import React, { useState } from "react"
import {  FiBell, FiCheckCircle, FiXCircle } from "react-icons/fi"

export const Notifications = () => {
    const [status, setStatus] = useState(false)

    return (
           
        <div 
        onClick={()=>setStatus(!status)}
        className="relative hover:bg-white/20 rounded-full w-12 h-12 flex items-center justify-center cursor-pointer">
          <FiBell size={23} className="h-5 text-gray-400" /> 
          <span className="flex h-2 w-2 absolute top-2 right-2">
              <span className="animate animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
          </span>
          {/** OPTIONS COMPONENT **/}
          {status && (
            <div
            // :className="status == true ? 'block':'hidden'"
            className="dropdown absolute right-0 top-14 z-10 divide-y border dark:border-zinc-700 
            dark:border-zinc-900 bg-white dark:bg-zinc-800 rounded-lg w-72 z-[55]"
            >
              <div className="my-3">
              <div className="flex items-center justify-between mx-3 mb-5">
                  <div className="flex items-center gap-2">
                  <div
                      className="text-sm bg-red-500 rounded-full w-5 h-5 text-white font-medium flex items-center justify-center"
                  >
                      5
                  </div>
                  <div className="font-semibold dark:text-white">Notifications</div>
                  </div>
                  <div className="flex">
                  <div
                      className="border-b-2 border-gray-200 dark:border-gray-500 text-sm text-gray-500 dark:text-gray-300 cursor-pointer p-1 px-3"
                  >
                      Unread
                  </div>
                  <div
                      className="border-b-2 border-blue-500 text-sm text-gray-500 dark:text-gray-300 cursor-pointer p-1 px-3"
                  >
                      All
                  </div>
                  </div>
              </div>
              <ul className="m-3">
                  <li>
                  <div className="flex gap-2 items-center mb-2">
                      <img
                      src="/images/avatars/Vector-3.png"
                      className="rounded-full w-12 h-12 cursor-pointer"
                      />
                      <div>
                      <div className="flex gap-2 items-center">
                          <div
                          className="text-gray-700 dark:text-gray-300 font-semibold cursor-pointer"
                          >
                          Jane Doe
                          </div>
                          <div className="text-gray-500 dark:text-gray-400 text-sm">
                          Sent message
                          </div>
                      </div>
                      <div className="text-gray-400 text-sm font-medium">
                          10 hours ago
                      </div>
                      </div>
                  </div>
                  </li>
                  <li>
                  <div className="flex gap-2 items-center mb-2">
                      <img
                      src="/images/avatars/Vector-4.png"
                      className="rounded-full w-12 h-12 cursor-pointer"
                      />
                      <div>
                      <div className="flex gap-2 items-center">
                          <div className="text-gray-500 dark:text-gray-400 text-sm">
                          Missed call from
                          </div>
                          <div
                          className="text-gray-700 dark:text-gray-300 font-semibold cursor-pointer"
                          >
                          Jasmine
                          </div>
                      </div>
                      <div className="text-gray-400 text-sm font-medium">
                          1 days ago
                      </div>
                      <div
                          className="bg-gray-200 dark:bg-gray-600 cursor-pointer p-1 px-3 my-2 rounded-md w-max flex items-center justify-center text-gray-500 dark:text-gray-300"
                      >
                          <i
                          data-feather="phone"
                          className="text-gray-500 dark:text-gray-300 h-4"
                          ></i>
                          <p>Call Back</p>
                      </div>
                      </div>
                  </div>
                  </li>
                  <li>
                  <div className="flex gap-2 items-center mb-2">
                      <img
                      src="/images/avatars/Vector-5.png"
                      className="rounded-full w-12 h-12 cursor-pointer"
                      />
                      <div>
                      <div className="flex gap-2 items-center">
                          <div
                          className="text-gray-700 dark:text-gray-300 font-semibold cursor-pointer"
                          >
                          Jessica
                          </div>
                          <div className="text-gray-500 dark:text-gray-400 text-sm">
                          Added you
                          </div>
                      </div>
                      <div className="text-gray-400 text-sm font-medium">
                          2 days ago
                      </div>
                      <div className="flex gap-2">
                          <div
                          className="bg-blue-500 cursor-pointer p-2 px-3 my-2 rounded-md w-max flex items-center justify-center text-white text-sm"
                          >
                          <FiCheckCircle size={23}
                              className="text-gray-500 h-4 text-white"
                          />
                          <p>Accept</p>
                          </div>
                          <div
                          className="bg-gray-200 dark:bg-gray-600 cursor-pointer p-2 px-3 my-2 rounded-md w-max flex items-center justify-center text-gray-500 dark:text-gray-300 text-sm"
                          >
                          <FiXCircle size={23}
                              className="text-gray-500 dark:text-gray-300 h-4"
                          />
                          <p>Reject</p>
                          </div>
                      </div>
                      </div>
                  </div>
                  </li>
                  <li>
                  <div className="flex gap-2 items-center mb-2">
                      <img
                      src="/images/avatars/Vector-7.png"
                      className="rounded-full w-12 h-12 cursor-pointer"
                      />
                      <div>
                      <div className="flex gap-2 items-center">
                          <div
                          className="text-gray-700 dark:text-gray-300 font-semibold cursor-pointer"
                          >
                          Jamie
                          </div>
                          <div className="text-gray-500 dark:text-gray-400 text-sm">
                          Sent message
                          </div>
                      </div>
                      <div className="text-gray-400 text-sm font-medium">
                          1 weeks ago
                      </div>
                      </div>
                  </div>
                  </li>
              </ul>
              </div>
            </div>
          )}
        </div>

    ) 
  }